import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { FaFile } from "react-icons/fa6";
import toast from "react-hot-toast";
import { updateTaskDataSources } from "./../../services/api"; // Import fetch-based API service
import { FaCheckCircle } from "react-icons/fa";
import Loader2 from "./../custom/Loader2";

const DataSourceSelectionModal = ({ closeModal, files, currentDataSources, setCurrentDataSources }) => {

  // Pre-select the currently selected files based on the full file objects
  const [selectedDataSources, setSelectedDataSources] = useState([
    ...currentDataSources,
  ]);
  const [isloading, setIsloading] = useState(false);
  const [error, setError] = useState(null);

  const handleSelect = (file) => {
    setSelectedDataSources(
      (prevSelected) =>
        prevSelected.find((selected) => selected.file_id === file.file_id)
          ? prevSelected.filter((selected) => selected.file_id !== file.file_id) // Remove if already selected
          : [...prevSelected, file] // Add if not selected
    );
  };

  const handleConfirm = async () => {
    try {
      // Extract file IDs to send to the API
      const selectedFileIds = selectedDataSources.map((file) => file.file_id);
    //   setIsloading(true);
      // Call API to update task data sources using fetch
      
        setCurrentDataSources(selectedDataSources);
        toast.success("Selected data sources updated");
        closeModal(); // Close the modal
        return;
      
    //   const result = await updateTaskDataSources(
    //     taskId,
    //     userGoogleId,
    //     selectedFileIds
    //   );

    //   if (result.error) {
    //     setIsloading(false);
    //     throw new Error(result.error);
    //   }

    //   setCurrentDataSources(selectedDataSources); // Update the full file info in context
    //   toast.success("Selected data sources updated");
    //   setIsloading(false);

    //   closeModal(); // Close the modal
    } catch (err) {
      setError("Failed to update data sources");
      setIsloading(false);
      toast.error(err.message);
    }
  };

  return (
    <div className="flex w-full">
      <div className="text-white rounded-lg shadow-lg relative w-full">
        <div className="space-y-3">
          <ul className="space-y-2">
            {files.map((file) => {
              if (file.status != "success" && !file.accessible) {
                return null;
              }
              const isSelected = selectedDataSources.some(
                (selected) => selected.file_id === file.file_id
              );
              return (
                <li
                  key={file.file_id}
                  onClick={() => handleSelect(file)}
                  className={`flex justify-between items-center rounded-md w-full p-3 cursor-pointer ${
                    isSelected
                      ? "bg-white text-black"
                      : "bg-zinc-800 text-white"
                  }`}
                >
                  <div className="flex items-center gap-2 max-w-[70%]">
                    <span>
                      <FaFile className="text-[#5566FF] text-lg" />
                    </span>
                    <span
                      className={`text-sm truncate ${
                        isSelected ? "text-black" : "text-white"
                      }`}
                      title={`${file.original_filename}\nUploaded at: ${file.timestamp}`}
                    >
                      {file.original_filename}
                    </span>
                  </div>

                  {isSelected ? (
                    <FaCheckCircle className="text-green-500 w-3 h-full" />
                  ) : (
                    <div className="border hover:border-cyan-500 rounded-full w-3 h-3"></div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
        <div className="flex justify-end">
          <button
            onClick={handleConfirm}
            disabled={isloading}
            className="bg-zinc-200 text-zinc-800 px-3 py-1 rounded-lg mt-4 flex items-center gap-1"
          >
            {/* Confirm */}
            {isloading && <Loader2 />}
            {isloading ? "Confirming" : "Confirm"}
          </button>
        </div>
        {error && <div className="text-red-500 mb-4">{error}</div>}
      </div>
    </div>
  );
};

export default DataSourceSelectionModal;
